module.exports = __webpack_public_path__ + "static/media/Andre_Torlen_Lonvik.c156bb0c.jpg";